import { BaseModal } from 'layout'

export default function ModalProtocollazione(props) {
  const {
    documentoInput,
    propsEntita,
    chiudiModifica,
    documentoCongelato,
    ProtocollazioneDocumento,
  } = props

  return (
    <BaseModal
      titolo='Protocollazione documento'
      open={true}
      onClose={chiudiModifica}
      contenutoNonCentrato
      maxWidth='md'
      disabilitaChiusuraCliccandoFuori
      nascondiBottoneChiudi
    >
      <ProtocollazioneDocumento
        documentoInput={documentoInput}
        pathDocumento={propsEntita.pathEntita}
        documentoCongelato={documentoCongelato}
        chiudiModifica={chiudiModifica}
      />
    </BaseModal>
  )
}